// L-78: kịch bản sơ đồ chạy dưới mã bản chạy được "kb-<id>" — mã máy, người dùng không biết là kịch bản nào. tenKb() trả một <span>,
// hỏi GỘP máy chủ (GET /api/ten-kich-ban, nhớ trong phiên trang) để thay bằng TÊN kịch bản. Tên khác dạng kb-… (kịch bản học/dạy trong
// plugin) giữ nguyên. Mọi chữ dựng bằng textContent (tên có ký tự đặc biệt hiện đúng dạng chữ).
// N9 (rà soát 05/10/2026): mã chỉ còn trong tooltip; Super (chế độ kỹ thuật) thấy thêm mã nhỏ mờ. Tên BƯỚC thay mã bước: tenBuoc() /
// ganLyDo() hỏi gộp GET /api/ten-buoc (bản đồ id bước → "Bước n · tên thao tác" theo sơ đồ của kịch bản + bảng tên chung).
import { api, buildQuery } from "./api";
import { h } from "./dom";
import { hienTenBuoc, thayMaBuoc, type TenBuocKb } from "./format";
import { isSuper, store } from "./store";

const MA_KB = /^kb-[a-z0-9]{4,40}$/;
/** N11: tên bundle là của kịch bản SƠ ĐỒ (kb-…) → đã hiện ở danh sách Kịch bản chính; tên khác = kịch bản học trên bot. */
export const laMaKbSoDo = (bundleName: string): boolean => MA_KB.test(bundleName);
type KetQuaTen = { id: string; ten: string } | null;
const daBiet = new Map<string, KetQuaTen>();
const choHoi = new Map<string, ((v: KetQuaTen | undefined) => void)[]>();
let henGio: ReturnType<typeof setTimeout> | null = null;

async function hoiGop(): Promise<void> {
  henGio = null;
  const ma = [...choHoi.keys()];
  const ds = new Map(choHoi);
  choHoi.clear();
  for (let i = 0; i < ma.length; i += 200) {
    const phan = ma.slice(i, i + 200);
    let items: { bundleName: string; id: string; ten: string }[] | null = null;
    try { items = (await api<{ items: { bundleName: string; id: string; ten: string }[] }>("GET", `/api/ten-kich-ban${buildQuery({ ma: phan.join(",") })}`)).items; } catch { /* lỗi mạng: giữ chữ đang hiện, lần sau hỏi lại */ }
    const theoMa = new Map((items ?? []).map((x) => [x.bundleName, { id: x.id, ten: x.ten }]));
    for (const m of phan) {
      // items null = không hỏi được → undefined (không nhớ); hỏi được mà không có = kịch bản đã xoá / không thuộc mình → null (nhớ).
      const v = items ? theoMa.get(m) ?? null : undefined;
      if (v !== undefined) daBiet.set(m, v);
      for (const f of ds.get(m) ?? []) f(v);
    }
  }
}

/** Hỏi tên kịch bản cho mã kb-… (gộp nhiều lời gọi trong cùng một nhịp thành một request). v = undefined khi không hỏi được máy chủ. */
export function layTenKb(bundleName: string, f: (v: KetQuaTen | undefined) => void): void {
  if (!MA_KB.test(bundleName)) return;
  if (daBiet.has(bundleName)) { f(daBiet.get(bundleName)!); return; }
  const ds = choHoi.get(bundleName) ?? [];
  ds.push(f);
  choHoi.set(bundleName, ds);
  if (!henGio) henGio = setTimeout(() => void hoiGop(), 0);
}

/** Tên đã biết (đã hỏi máy chủ trước đó) cho câu dựng ngay (hộp xác nhận, thông báo); chưa biết → chính chuỗi đưa vào. */
export function tenKbDaBiet(bundleName: string): string {
  return daBiet.get(bundleName)?.ten ?? bundleName;
}

/** Mã nhỏ mờ chỉ cho Super (chế độ kỹ thuật); người dùng thường chỉ thấy mã trong tooltip. */
function maKyThuat(ma: string, laBuoc = false): HTMLElement | null {
  // (đợt B3) mã BƯỚC chỉ hiện khi Super bật Chế độ kỹ thuật (trước đây Super nào cũng thấy "Đăng bài vào nhóm (dang_bai_nhom)"); mã kịch bản giữ như N9
  return isSuper() && (!laBuoc || store.kyThuat) ? h("span", { class: "muted small ten-kb-ma" }, ` (${ma})`) : null;
}

/** Ô hiện kịch bản: TÊN (có liên kết tới trang kịch bản khi `lienKet`); mã chỉ trong tooltip (Super thấy thêm mã nhỏ). Không phải kịch bản sơ đồ → tên như cũ. */
export function tenKb(bundleName: string, opts: { lienKet?: boolean } = {}): HTMLSpanElement {
  const laKb = MA_KB.test(bundleName);
  const o = h("span", { class: "ten-kb", title: laKb ? `Mã kịch bản: ${bundleName}` : bundleName, dataset: { bundle: bundleName } }, laKb ? "Kịch bản…" : bundleName);
  layTenKb(bundleName, (v) => {
    if (v === undefined) { o.textContent = bundleName; return; } // không hỏi được máy chủ → hiện mã như trước, còn hơn chữ chờ mãi
    o.textContent = "";
    if (!v) { o.append(h("span", { class: "muted" }, "Kịch bản đã xoá"), maKyThuat(bundleName) ?? ""); return; }
    o.title = `${v.ten} — mã kịch bản: ${bundleName}`;
    o.append(opts.lienKet && v.id ? h("a", { href: `#/kich-ban/${encodeURIComponent(v.id)}`, title: "Mở kịch bản này" }, v.ten) : v.ten, maKyThuat(bundleName) ?? "");
  });
  return o;
}

/** Bản chữ (cho <option>, tiêu đề hộp thoại, liên kết…): chỉ TÊN khi biết tên (mã vào tooltip). `mau` dựng câu từ tên. */
export function ganTenKbChu(el: HTMLElement, bundleName: string, mau: (ten: string) => string = (ten) => ten): void {
  layTenKb(bundleName, (v) => {
    if (!v) return;
    el.textContent = mau(v.ten);
    if (!(el instanceof HTMLOptionElement)) el.title = `${v.ten} — mã kịch bản: ${bundleName}`;
  });
}

/** Chỉ dùng trong test đơn vị / khi đổi tài khoản: quên tên đã nhớ. */
export function quenTenKb(): void { daBiet.clear(); buocDaBiet.clear(); chungDaBiet = null; }

// ---------------- N9: tên bước ----------------
const buocDaBiet = new Map<string, Record<string, TenBuocKb>>();
let chungDaBiet: Record<string, string> | null = null;
const choBuoc = new Map<string, ((tra: (stepId: string) => string, biet: (stepId: string) => string | null) => void)[]>();
let henBuoc: ReturnType<typeof setTimeout> | null = null;

function boTra(bundleName: string): { tra: (id: string) => string; biet: (id: string) => string | null } {
  const kb = buocDaBiet.get(bundleName);
  const chung = chungDaBiet ?? {};
  const tra = (id: string) => hienTenBuoc(id, kb, chung);
  const biet = (id: string) => (kb && Object.prototype.hasOwnProperty.call(kb, id)) || Object.prototype.hasOwnProperty.call(chung, id) || Object.prototype.hasOwnProperty.call(chung, id.replace(/_\d+$/, "")) ? tra(id) : null;
  return { tra, biet };
}

async function hoiBuocGop(): Promise<void> {
  henBuoc = null;
  const ma = [...choBuoc.keys()];
  const ds = new Map(choBuoc);
  choBuoc.clear();
  for (let i = 0; i < ma.length; i += 200) {
    const phan = ma.slice(i, i + 200);
    try {
      const r = await api<{ items: { bundleName: string; buoc: Record<string, TenBuocKb> }[]; chung: Record<string, string> }>("GET", `/api/ten-buoc${buildQuery({ ma: phan.join(",") })}`);
      chungDaBiet = r.chung ?? chungDaBiet ?? {};
      for (const it of r.items) buocDaBiet.set(it.bundleName, it.buoc ?? {});
      for (const m of phan) if (!buocDaBiet.has(m)) buocDaBiet.set(m, {});
    } catch { /* không hỏi được → vẫn hiện tên suy từ mã (bỏ dấu gạch dưới) */ }
    for (const m of phan) { const { tra, biet } = boTra(m); for (const f of ds.get(m) ?? []) f(tra, biet); }
  }
}

/** Gọi f với hàm tra tên bước của kịch bản `bundleName` (gộp mọi kịch bản hỏi trong cùng một nhịp thành một request). */
export function layTenBuoc(bundleName: string, f: (tra: (stepId: string) => string, biet: (stepId: string) => string | null) => void): void {
  const ma = bundleName || "";
  if (buocDaBiet.has(ma) && chungDaBiet) { const { tra, biet } = boTra(ma); f(tra, biet); return; }
  const ds = choBuoc.get(ma) ?? [];
  ds.push(f);
  choBuoc.set(ma, ds);
  if (!henBuoc) henBuoc = setTimeout(() => void hoiBuocGop(), 0);
}

/** Ô tên bước: "Bước 2 · Bình luận các bài tìm được" thay "dang_binh_luan"; mã trong tooltip (Super thấy thêm mã nhỏ). */
export function tenBuoc(bundleName: string, stepId: string): HTMLSpanElement {
  const o = h("span", { class: "ten-buoc", title: `Mã bước: ${stepId}`, dataset: { step: stepId } }, hienTenBuoc(stepId, undefined, undefined));
  layTenBuoc(bundleName, (tra) => {
    o.textContent = tra(stepId);
    const ma = maKyThuat(stepId, true);
    if (ma) o.append(ma);
  });
  return o;
}

/** Câu lý do lỗi/dừng: thay mã bước trong câu bằng tên bước khi biết ("lay_bai: không định vị…" → "Bước 1 · Tìm bài viết: …"). */
export function ganLyDo(el: HTMLElement, bundleName: string, text: string | null | undefined): void {
  const goc = text ?? "";
  el.textContent = goc;
  if (!goc || !/[a-z]_[a-z]|^[a-z]+: /.test(goc)) return; // câu không có dạng mã bước → khỏi hỏi máy chủ
  layTenBuoc(bundleName, (_tra, biet) => {
    const moi = thayMaBuoc(goc, biet);
    if (moi !== goc) { el.textContent = moi; el.title = `Nguyên văn: ${goc}`; }
  });
}
